import { Stack, Text } from "@mantine/core";
import { StatusPill } from "../StatusPill";

/**
 * The all-verified state: the run is `clean`, every finalized ticket was
 * independently confirmed live on Meta with the expected ads. No discrepancies,
 * nothing to act on. Composed from Mantine `Stack`/`Text` (U6).
 */
export function CleanSummary() {
  return (
    <Stack align="center" gap="sm" py="xl" px="md" ta="center">
      <div>
        <StatusPill kind="verdict" value="verified_ok" />
      </div>
      <Text fw={600} fz="lg">
        Everything checks out
      </Text>
      <Text c="dimmed" fz="sm" maw={420}>
        Every finalized ticket was independently verified against Meta — live
        with the expected ads. No discrepancies to resolve.
      </Text>
    </Stack>
  );
}
